<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editForm" ref="editFormRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">处理方式</span>
          </label>
          <el-input type="textarea" :rows="5" v-model="editForm.process"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">单次维修金额</span>
          </label>
          <el-input v-model="editForm.money"></el-input>
        </el-form-item>
        <el-form-item label="附件(可选)" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
          默认采用上次的附件，如果附件有改动，请把所有附件都重新上传。
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf
  },
  data () {
    return {
      editForm: {
        id: '0',
        orderid: '',
        process: '',
        money: '0',
        attachment: ''
      }
    }
  },
  mounted () {

  },
  methods: {
    LoadData (row) {
      console.log(row)
      this.editForm.id = row.Id
      this.editForm.orderid = row.Orderid
      this.editForm.process = row.Process
      this.editForm.money = row.Money
      this.editForm.attachment = row.Attachment
      this.$refs.MultiImgOrPdf.cleardata()
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditAfterSalesServiceOrderTrack()
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.editForm.attachment = url
    },
    apiEditAfterSalesServiceOrderTrack: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editForm.id,
        orderid: that.editForm.orderid,
        process: that.editForm.process,
        money: that.editForm.money,
        attachment: that.editForm.attachment
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditAfterSalesServiceOrderTrack, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
